import {SmsNotificationDataApiDto} from "../../../api/model/rest";
import {none, option, Option} from "ts-option";

/**
 * Sms notification class data.
 */
export default class SmsNotificationData {
	/**
	 * @param {string} smsContent sms content.
	 * @param {string} notificationSubtype sms notification subtype.
	 * @param {string} phoneNumber sender number.
	 * @param {Option<RecognizedSmsData>} recognizedSmsData recognized sms custom data.
	 */
	constructor(public readonly smsContent: string,
		public readonly notificationSubtype: string,
		public readonly phoneNumber: string,
		public readonly recognizedSmsData: Option<RecognizedSmsData>) {}

	static fromJson(json: SmsNotificationDataApiDto): SmsNotificationData {
		const recognizedSmsData = json.leadId ? option(new RecognizedSmsData(
			json.contactId, json.leadId, json.referenceNumber, json.contactFullName
		)) : none;
		return new SmsNotificationData(json.smsContent, json.notificationSubtype, json.phoneNumber, recognizedSmsData);
	}
}

/**
 * Data for recognized SMS that it's connected with lead and contact.
 */
export class RecognizedSmsData {
	constructor(public readonly contactId: string,
		public readonly leadId: string,
		public readonly referenceNumber: string,
		public readonly contactFullName: string) {}
}

/**
 * Sms notification subtype.
 */
export enum SmsSubTypeEnum {
	RecognizedSender = "RECOGNIZED_SENDER",
	UnknownSender = "UNRECOGNIZED_SENDER"
}